/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import {
  Image,
  Form,
  Button,
  Input,
  Result,
  Toast,
  Mask,
} from "antd-mobile-v5";
import styled from "styled-components";
import { getQueryString } from "../../util/getQueryString";
import { useHistory } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import instance from "../../util/axios";
import CryptoJs from "crypto-js";
import { useLocalStorage } from "react-use";

interface LoginInfo {
  corporation: string;
  account: string;
  password: string;
  remember: boolean;
}
const RegisterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f8f8f7;
  .navBar {
    background: #fff;
  }
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .logo {
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 20px;
    width: 130px;
  }
  .user-box {
    text-align: center;
    margin-bottom: 80px;
    margin-top: 80px;
    font-size: 14px;
    color: #cccccc;
    font-weight: 600;
  }
  .user {
    color: #1677ff;
  }
  .company-box {
    text-align: center;
    margin-bottom: 40px;
    font-size: 20px;
    font-weight: 600;
  }
  .adm-form {
    flex: 1;
    display: flex;
    flex-direction: column;
    .adm-list {
      flex: 1;
    }
    .adm-list-body-inner {
      padding: 0 8px;
      font-size: 15px;
    }
  }
  .pc-form {
    .adm-list {
      flex: none;
    }
  }
  .adm-input-element {
    font-size: 15px;
  }
`;
export function isMobile() {
  let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  return flag;
}

const advisorId: string = getQueryString("advisorId") || "";
const source: string = getQueryString("source") || "";
const expiringDate = Number(getQueryString("expiringDate") || "1");
const currentDate = new Date().getTime();
let maxTime = 60;
export default function WithDownload() {
  const [form] = Form.useForm();

  const [codeInfo, setCodeInfo] = useState<{
    btnDisabled: boolean;
    btnText: string;
    mobile: string;
  }>({
    btnDisabled: false,
    btnText: "发送",
    mobile: "",
  });

  const [, setLoginType] = useLocalStorage<"account" | "mobile">(
    "loginType",
    "account"
  );
  const [, setRecentLoginInfo] = useLocalStorage<LoginInfo>("login", {
    corporation: "",
    account: "",
    password: "",
    remember: false,
  });
  let u = navigator.userAgent,
    ua = u.toLowerCase();

  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isIOS9, setIsIOS9] = useState(false);
  const [isWeixin, setIsWeixin] = useState(false);

  //检查系统和版本
  function checkSystem() {
    if (ua.indexOf("micromessenger") > -1) {
      setIsWeixin(true);
      return;
    } else if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
      //android终端或者uc浏览器
      //Android系统
      setIsAndroid(true);
    }
    if (ua.indexOf("like mac os x") > 0) {
      //ios
      var regStr_saf = /os [\d._]*/gi;
      var verinfo = ua.match(regStr_saf);
      let version = Number(
        (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".")
      );
      var version_str = version + "";
      if (version_str != "undefined" && version_str.length > 0) {
        if (version >= 8) {
          // ios9以上

          setIsIOS9(true);
        } else {
          setIsIOS(true);
        }
      }
    }
  }

  const [visible, setVisible] = useState(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const toDownLoad = () => {
    if (isIOS || isIOS9) {
      goIOSAddr();
    } else if (isAndroid) {
      goAndriAddr();
    } else if (isWeixin) {
      setVisible(true);
    }
  };
  function goAndriAddr() {
    Toast.show(ua);
    //跳转到安卓商城地址
    let isVivo = ua.indexOf("vivo") != -1;
    let isHuawei = ua.indexOf("huawei") != -1 || ua.indexOf("honor") != -1;
    let isMi = ua.indexOf("redmi") != -1 || ua.indexOf("xiaomi") != -1;
    let isMeizu = ua.indexOf("meizu") != -1;
    let isSamsung = ua.indexOf("sm") != -1;
    let isOppo = ua.indexOf("pacm00") != -1 || ua.indexOf("oppo") != -1;
    let hreff = "";
    if (isVivo) {
      hreff = "vivoMarket://details?id=com.tysoft";
    } else if (isHuawei) {
      hreff = "appmarket://details?id=com.tysoft";
    } else if (isMi) {
      hreff = "mimarket://details?id=com.tysoft";
    } else if (isMeizu) {
      hreff = "mstore://details?id=com.tysoft";
    } else if (isSamsung) {
      hreff = "samsungapps://ProductDetail/com.tysoft";
    } else if (isSamsung) {
      hreff = "samsungapps://ProductDetail/com.tysoft";
    } else if (isOppo) {
      hreff = "oppomarket://details?packagename=com.tysoft";
    } else {
      hreff = "tmast://appdetails?pname=com.tysoft"; // 官网下载地址  也可以跳到应用宝
    }
    console.log(hreff);
    window.location.href = hreff;
  }
  function goIOSAddr() {
    window.location.href = "https://apps.apple.com/cn/app/id1575506556";
  }
  const onRegister = useCallback(
    (
      enterpriseName: any,
      contractName: any,
      password: any,
      repassword: any
    ) => {
      instance
        .post("/oa/registerDetail/registerEnterprise", {
          enterpriseName: enterpriseName,
          contractName: contractName,
          password: password,
          repassword: repassword,
          mobilePhone: form.getFieldValue("mobile"),
          validateCode: "",
          setMeal: "06c604b1095c41f2ae205f4d55c5a35f",
        })
        .then((resp) => {
          if (resp.data.Status === "1") {
            Toast.show({
              content: "注册成功",
            });
            const copy: any = {};
            copy.corporation = enterpriseName;
            copy.account = contractName;
            copy.password = "";
            copy.remember = false;
            instance.post(`/crm/customer/registerWithLeadOrCustomer`, {
              enterpriseName: enterpriseName,
              mobilePhone: form.getFieldValue("mobile"),
              advisorId: advisorId,
              source: source,
            });
            setLoginType("account");
            setRecentLoginInfo(copy);
            toDownLoad();
          } else {
            Toast.show({
              content: "注册失败",
            });
          }
        });
    },
    [form, setLoginType, setRecentLoginInfo, toDownLoad]
  );
  const onSubmit = async () => {
    const values = form.getFieldsValue();
    instance
      .post("/oa/registerDetail/checkEnterpriseName", {
        enterpriseName: values.enterpriseName,
      })
      .then((res) => {
        if (res.data.Status === "1") {
          onRegister(
            values.enterpriseName,
            values.name,
            values.password,
            values.repassword
          );
        } else {
          Toast.show({
            content: "企业名已经存在！",
          });
        }
      });
  };

  const sendCode = useCallback((mobile: string) => {
    const word = CryptoJs.MD5(`${mobile}tysoft`).toString();
    instance
      .post("/oa/registerDetail/newGetVerifyCode", {
        mobile: mobile,
        inCode: word,
      })
      .then((resp) => {
        if (resp.data.Status === "1") {
          Toast.show({
            content: "验证码发送成功",
          });
          const timer = setInterval(() => {
            if (maxTime > 0) {
              --maxTime;
              setCodeInfo((prevState) => ({
                ...prevState,
                btnText: `${maxTime}s`,
                btnDisabled: true,
                mobile: mobile,
              }));
            } else {
              clearInterval(timer);
              maxTime = 60;
              setCodeInfo((prevState) => ({
                ...prevState,
                btnText: "发送",
                btnDisabled: false,
                mobile: mobile,
              }));
            }
          }, 1000);
        } else {
          //
        }
      });
  }, []);

  const checkPhoneNumber = useCallback(async (mobile: string) => {
    return await instance.post("/oa/registerDetail/checkPhoneNumber", {
      num: mobile,
    });
  }, []);

  useEffect(() => {
    document.title = "注册";
  }, []);

  return (
    <RegisterWrapper style={{ background: isMobile() ? "#f8f8f7" : "#fff" }}>
      <>
        <main className="main">
          <Image className="logo" src={"/logo.png"} />
          <div className="user-box">欢迎使用「软湖」，请填写注册信息</div>
          <Form
            layout="horizontal"
            onFinish={onSubmit}
            form={form}
            className={isMobile() ? "mobile-form" : "pc-form"}
            style={{ width: isMobile() ? "100%" : "400px", margin: "0 auto" }}
            footer={
              <Button block type="submit" color="primary" size="large">
                注册
              </Button>
            }
          >
            <Form.Item
              name="enterpriseName"
              label="企业名称"
              rules={[{ required: true, message: "企业名称不能为空" }]}
            >
              <Input placeholder="请输入" autoFocus className="fs14" />
            </Form.Item>
            <Form.Item
              name="name"
              label="用户名"
              rules={[{ required: true, message: "用户名不能为空" }]}
            >
              <Input placeholder="请输入" autoFocus className="fs14" />
            </Form.Item>
            <Form.Item
              name="mobile"
              label="手机号"
              rules={[
                { required: true, message: "手机号不能为空" },
                {
                  pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                  message: "手机号格式错误！",
                },
              ]}
            >
              <Input placeholder="请输入" className="fs14" />
            </Form.Item>
            <Form.Item
              label="验证码"
              name="code"
              rules={[{ required: true, message: "验证码不能为空" }]}
              extra={
                codeInfo.btnDisabled ? (
                  <span>{codeInfo.btnText}</span>
                ) : (
                  <a
                    onClick={async () => {
                      const mobile = form.getFieldValue("mobile");
                      const re = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                      if (!mobile) {
                        Toast.show({
                          content: "请输入手机号",
                        });
                        return;
                      }
                      if (!re.test(mobile)) {
                        return;
                      }
                      const resp = await checkPhoneNumber(
                        form.getFieldValue("mobile")
                      );
                      if (resp.data.Status === "0") {
                        Toast.show({
                          content: resp.data.Data,
                        });
                        return;
                      }
                      sendCode(form.getFieldValue("mobile"));
                    }}
                  >
                    {codeInfo.btnText}
                  </a>
                )
              }
            >
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item
              name="password"
              label="密码"
              rules={[
                { required: true, message: "密码不能为空" },
                {
                  pattern: /^[A-Za-z0-9]{6,}$/,
                  message: "密码长度至少六位",
                },
              ]}
            >
              <Input
                // clearable
                type="password"
                placeholder="请输入"
                className="fs14"
              />
            </Form.Item>
            <Form.Item
              name="repassword"
              label="再次输入"
              rules={[
                { required: true, message: "密码不能为空" },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject("两次输入的密码不匹配");
                  },
                }),
                {
                  pattern: /^[A-Za-z0-9]{6,}$/,
                  message: "密码长度至少六位",
                },
              ]}
            >
              <Input
                // clearable
                type="password"
                placeholder="请输入"
                className="fs14"
              />
            </Form.Item>
          </Form>
        </main>

        <Mask visible={visible} onMaskClick={() => setVisible(false)} />
        <Image
          src={"/tip.png"}
          style={{
            position: "absolute",
            width: "70%",
            zIndex: 9999,
            right: 20,
            top: 0,
            display: visible ? "block" : "none",
          }}
        />
      </>
    </RegisterWrapper>
  );
}
